import { Container } from 'theme-ui';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styles from '@features/voxbox/sections/Video/VideoSection.styles';
import { IVideo } from '@features/voxbox/typescript';
import theme from '@styles/theme';
import Heading from '@components/Heading/Heading';
import { useResponsive } from '@features/responsive';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  video: IVideo;
};
const VideoSection = ({
  video
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    t: tLayouts
  } = useTranslation('layouts');
  const {
    isWiderThanDesktop
  } = useResponsive();
  return <section sx={styles.section} data-cy="VideoSection">
      <Container sx={styles.container}>
        <div>
          <div sx={styles.laptopVideo}>
            <ResponsiveImage image={`${BASE_PATH}/img/voxbox/laptop.png`} alt="" objectFit="contain" />
            <a href={video.videoUrl} target="_blank" rel="noreferrer" title={`${video.header} ${tLayouts('footer.links.opensInNewWindow')}`}>
              <Icon addSx={styles.playerIcon} icon="Youtube" color="#fff" size="100px" />
            </a>
          </div>
          <div sx={styles.tryVoxbox}>
            <Heading display={3} color={theme.rawColors.neutralBlack} pb={24} mobile>
              {video.header}
            </Heading>
            <p>{video.description}</p>

            {video.buttons && <div sx={styles.buttonBox}>
                {!isWiderThanDesktop && <Link href={video.buttons.first.additionalLink || '#'} className="openModal">
                    {video.buttons.first.additionalText}
                  </Link>}
                <Link href={video.buttons.second.link} target={video.buttons.first.target}>
                  <Button variant="outlined" variantColor="dark">
                    {video.buttons.second.text}
                  </Button>
                </Link>
                {isWiderThanDesktop && <>
                    <span sx={styles.orEl}>{t('or')}</span>
                    <Link href={video.buttons.first.link} target={video.buttons.first.target}>
                      <Button variant="default" variantColor="dark">
                        {video.buttons.first.text}
                      </Button>
                    </Link>
                    <Link href={video.buttons.first.additionalLink || '#'} className="openModal">
                      {video.buttons.first.additionalText}
                    </Link>
                  </>}
              </div>}
          </div>
        </div>
      </Container>
    </section>;
};
export default VideoSection;